<template>
	<div>
		<div
			class="option flex"
			@click="handleClick"
			:class="{
				act: userSelect.includes(option.key),
				abd: userSelect.includes(option.key) && pageType == 'check',
				did: userSelect.includes(option.key) && wrongAnswer(option.key) && pageType == 'check'
			}"
		>
			<span class="multiple" v-if="question.type == 2"></span>
			<span style="color:#202020" v-if="question.type !== 3">{{ option.key }}. </span>
			<div class="option-cont flex flex-column flex-1">
				<span>{{ option.value }}</span>
				<!-- <img :class="{ mt20: option.content }" v-if="option.img" :src="option.img" mode=""/> -->
			</div>
		</div>
		<div v-if="option.type!=3&&option.file&&option.file.length">
			<!-- <img class="topic-img" v-for="(item,index) of option.file" :key="index" :src="item.url" @click="imgPreview(item)" alt=""> -->
			<div class="topic-img" v-for="(item,index) of option.file" :key="index" :style="{backgroundImage:`url(${item.url})`}" @click="imgPreview(item)"></div>
			<van-image-preview v-model="show" :images="image" @close="imgPreviewClose" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		option: {
			type: Object,
			default: () => ({ type: 0, title: '' })
		},
		testType: {
			type: Number,
			default: 0 // 0 答题 1 背题 2 顺序答题 3 查看试卷
		},
		question: {
			type: Object,
			default: () => ({})
		},
		orderType: {
			type: Number,
			default: 0 // 顺序刷题的两种状态 答题模式 0	背题模式 1
		},
		userSelect: {
			type: Array,
			default: () => []
		},
		index: {
			type: Number,
			default: 0
		},
		pageType:{
			type:String,
			default:'do'
		}
	},
	created(){
	},
	data() {
		return {
			canChangeList: [0, 2],
			optionTxtList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
			image:[],
      show:false
		};
	},
	computed: {
		wrongAnswer(){
			return function(key){
				if(!this.question.answer) return false
				if(!this.question.answer.includes(key)){
					return true
				}
				return false
			}
		}
	},
	methods: {
	handleClick() {
			this.$emit('click');
	},
	imgPreview(item){
      this.show=true
      this.image.push(item.url)
      console.log(this.image);
    },
    imgPreviewClose(){
      this.image=[]
      this.show=false
    }
	}
};
</script>
<style lang="scss" scoped>
@import url('../../../../css/flex.scss');
.option {
	padding: 16px;
	font-size: 16px;
	background: #ffffff !important;
	border-radius: 8px;
	margin: 0 0 8px;
	border: 1px solid #f0f4f5;
	position: relative;
	align-items: center;
	.multiple {
		display: inline-block;
		width: 10px;
		height: 10px;
		background: #ffffff;
		border: 2px solid #e3e8e9;
		border-radius: 50%;
		margin-right: 8px;
	}
	&.act {
		background-color: #EAF1FF !important;
		border: #F0F4F5 1px solid;
		.multiple {
			width: 6px;
			height: 6px;
			border: 4px solid #286bff;
		}
		// color: #0bb65d;
	}
	&.abd {
		background-color: #E8F8F3 !important;
		border: #10B881 1px solid;
	}
	&.did {
		background-color: rgba(255,137,130,0.10) !important;
		border: #FF8982 1px solid;
		// color: #0bb65d;
	}
	> text {
		color: #888;
		word-break: break-all;
	}
	&-cont {
		padding: 0 34px 0 8px;
		> img {
			width: 80px;
			height: 80px;
			&.mt20{
				margin-top: 10px;
			}
		}
	}
	> img {
		width: 20px;
		height: 20px;
		position: absolute;
		top: 14px;
		right: 16px;
	}
}
  .topic-img{
    width: 106px;
    height: 60px;
	margin-bottom: 8px;
	border-radius: 6px;
	display: flex;
    flex-wrap: wrap;
	background-position: center;
	background-size: cover;
    background-repeat: no-repeat;
  }
</style>
